import { Api } from "./api"

const PATH = 'annonce' 
const ENDPOINTS = {
    Liste:'liste',
    Store:'store',
    Show:'show',
    Update:'update',
    Delete:'delete',
    Check:'check',
    Reactivate:'reactivate',
}

const getAnnouncements = (signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Liste}`, signal)
}

const getAnnouncement = (id,signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Show}/${id}`, signal)
}

const storeAnnonce = (payload, signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Store}/`, payload, signal)
}

const updateAnnonce = (id, payload, signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Update}/${id}`, payload, signal)
}

const deleteAnnouncement = (id,signal) => {
    return Api.erase(`${PATH}/${ENDPOINTS.Delete}/${id}`, signal)
}

const checkAnnouncement = (id,signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Check}/${id}`, signal)
}

const reactivateAnnonce = (id, delayExpiration, signal) => {
    const payload = delayExpiration ? JSON.stringify({ delay_expiration: delayExpiration }) : JSON.stringify({});
    return Api.post(`${PATH}/${ENDPOINTS.Reactivate}/${id}`, payload, signal)
}

const deleteAnnonceMedia = (mediaId, signal) => {
    return Api.erase(`${PATH}/${mediaId}/delete-media-image`, signal)
}

export const annonceApi = {
    getAnnouncements,
    getAnnouncement,
    storeAnnonce,
    updateAnnonce,
    deleteAnnouncement,
    checkAnnouncement,
    reactivateAnnonce,
    deleteAnnonceMedia,
}